// custom typefaces
import "@fontsource/playfair-display"
import "@fontsource/inter"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Apply theme immediately on client entry
export const onClientEntry = () => {
    const savedTheme = localStorage.getItem('theme') || 'dark'
    document.body.setAttribute('data-theme', savedTheme)
}
